import { render, staticRenderFns } from "./supplier-add.vue?vue&type=template&id=47b636ee&scoped=true"
import script from "./supplier-add.vue?vue&type=script&lang=js"
export * from "./supplier-add.vue?vue&type=script&lang=js"
import style0 from "./supplier-add.vue?vue&type=style&index=0&id=47b636ee&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b636ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b636ee')) {
      api.createRecord('47b636ee', component.options)
    } else {
      api.reload('47b636ee', component.options)
    }
    module.hot.accept("./supplier-add.vue?vue&type=template&id=47b636ee&scoped=true", function () {
      api.rerender('47b636ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/base-data/supplier-add.vue"
export default component.exports